export default "__VITE_ASSET__Baw6yIJd__"